import { useEffect, useState } from "react";
import { Button } from "react-bootstrap";
import { useParams } from "react-router-dom";
import Grid, { GridColumn, GridHeader, GridRow } from "../../../components/Grid/Grid";
import { useDispatch } from "react-redux";
import { BsEye } from "react-icons/bs";
import { connect, useSelector } from "react-redux";
import { projectUnitEditPageRequest, projectUnitsRequest, projectUnitDeleteConfirm, projectUnitDeleteDecline, projectUnitDeleteRequest } from "../ProjectUnitAction";
import { ProjectUnitInterface, ProjectUnitState, projectUnitStatus } from "../ProjectUnitTypes";
import { permissionsInterface, reduxInitialState } from "../../onBoarding/onBoardingTypes";
import { navigationRequest } from "../../../Navigation/NavigationRedux/NavigationRedux";
import PageTitle from "../../../components/PageTitle/PageTitle";
import { Pencil, Plus, Trash } from "react-bootstrap-icons";
import routePaths from "../../../Navigation/routePaths";
import DeleteModal from "../../../components/DeleteModal/DeleteModal";
import { bookingAddOrEditRequestPayload } from "../../Booking/BookingTypes";
import { bookingAddOrEditRequest } from "../../Booking/BookingsAction";
import ManageUnit from "./ManageUnit";

const headers: GridHeader[] = [
  {
    title: "Unit name",
    class: "text-left",
    isSorting: true,
    isAsc: true,
    sortingKey: "unit_name",
  },
  {
    title: "Total sq ft",
    class: "text-left",
    isSorting: true,
    isAsc: true,
    sortingKey: "area",
  },
  {
    title: "Length/ width",
    class: "text-left",
  },
  {
    title: "Status",
    class: "text-left",
    isSorting: true,
    isAsc: true,
    sortingKey: "status",
  },
  {
    title: "Is Cornor",
    class: "text-left",
    isSorting: false,
  },
  {
    title: "Facing",
    class: "text-left",
    isSorting: false,
  },
  {
    title: "Is Registration Done",
    class: "text-left",
    isSorting: false,
  },
    {
    title: "Is Mortgage",
    class: "text-left",
    isSorting: false,
  },
  {
    title: "Action",
    class: "text-center freeze-column",
    headerClass: "text-center",
    isSorting: false,
    isFilter: false,
    isFreeze: true,
  },
];

interface propData {
  getProjectUnits: (params: any) => void;
  onNavigate: (path: string) => void;
  editProjectUnit: (data: ProjectUnitInterface) => void;
  onDeleteProjectUnit: (id: string) => void;
  onCreateOrEditBooking: (data: bookingAddOrEditRequestPayload) => void;
}

const ProjectUnitPage = (props: propData) => {
  const dispatch = useDispatch();
  const { id }: any = useParams();
  const projectData: ProjectUnitState = useSelector((state: reduxInitialState) => state.ProjectUnitReducer);
  const [open, setOpen] = useState<boolean>(false);
  const [unitData, setUnitData] = useState<ProjectUnitInterface | null>(null);
  const token = useSelector((state: any) => state.OnBoardingReducer);
  const [permissions, setPermissions] = useState<permissionsInterface | null>(null);
  const [bookingPermissions, setBookingPermissions] = useState<permissionsInterface | null>(null);

  useEffect(() => {
    if (token && token.token && token.permissions && !!token.permissions.length) {
      setPermissions(token.permissions.find((item: any) => item.name === "PROJECTS"));
      setBookingPermissions(token.permissions.find((item: any) => item.name === "BOOKINGS"));
    }
  }, [token])

  const getProjectList = async (
    page: number,
    keyword?: string,
    startDate?: Date,
    endDate?: Date,
    order_by?: string,
    sort_by?: string
  ) => {
    !id && window.history.back();
    !projectData.loading &&
      props.getProjectUnits({
        page: page,
        keyword: keyword,
        fromDate: startDate,
        toDate: endDate,
        id: id,
        sort_by: sort_by || "unit_name",
        order_by: order_by || "asc",
      });
  };

  const onSortList = (offset: number, isAscending?: boolean, key?: string) => {
    getProjectList(
      offset,
      "",
      null as any,
      null as any,
      isAscending ? "asc" : "desc",
      key
    );
  };

  const getFormatedProjectRow = (list: ProjectUnitInterface[]) => {
    let rows: GridRow[] = [];
    for (var i in list) {
      let columns: GridColumn[] = [];
      columns.push({ value: list[i].unit_name ? list[i].unit_name : "N/A" });
      columns.push({ value: list[i].area ? Number(list[i].area).toFixed(2) + " sq. ft" : "N/A" });
      columns.push({ value: list[i].length + "/" + list[i].width });
      columns.push({ value: statusList(list[i].status) });
      columns.push({ value: list[i].is_corner ? "Yes" : "No" });
      columns.push({ value: list[i].facing_direction ? getFacingName(list[i].facing_direction) : "N/A" });
      columns.push({ value: list[i].is_registration ? "Yes" : "No" });
      columns.push({ value: list[i].is_mortgage ? "Yes" : "No" });
      columns.push({ value: ViewDetail(list[i]) });
      rows.push({ data: columns });
    }
    return rows;
  };

  const getFacingName = (facing: string) => {
    switch (facing) {
      case "NORTH":
        return "North";
      case "SOUTH":
        return "South";
      case "EAST":
        return "East";
      case "WEST":
        return "West";
      case "NORTH_EAST":
        return "North East";
      case "NORTH_WEST":
        return "North West";
      case "SOUTH_EAST":
        return "South East";
      case "SOUTH_WEST":
        return "South West";
      case "NORTH_SOUTH":
        return "North South";
      case "EAST_WEST":
        return "East West";
      case "NORTH_EAST_SOUTH_WEST":
        return "North East South West";
      case "NORTH_WEST_SOUTH_EAST":
        return "North West South East";
      case "NORTH_SOUTH":
        return "North South";
      case "EAST_WEST":
        return "East West";
      default:
        return "N/A";
    }
  };

  const statusList = (status: projectUnitStatus) => {
    if (
      status === projectUnitStatus.AVAILABLE ||
      status === projectUnitStatus.NOT_AVAILABLE
    ) {
      return (
        <span className="badge bg-success-subtle text-success">Available</span>
      );
    } else if (status === projectUnitStatus.BOOKED) {
      return (
        <span className="badge bg-danger-subtle text-warning">Booked</span>
      );
    } else if (status === projectUnitStatus.SOLD) {
      return <span className="badge bg-danger-subtle text-danger">Sold</span>;
    }
  };

  const ViewDetail = (data: ProjectUnitInterface) => {
    return (
      <span className="action-btns">
        {permissions && permissions.can_update && <button
          onMouseDown={() => props.editProjectUnit(data)}
          onClick={() => { props.onNavigate(routePaths.PROJECT_UNIT_UPDATE.path); }}
          className="cursor-pointer  btn-edit btn"
        >
          {" "}
          <Pencil />{" "}
        </button>}
        {(data.status === projectUnitStatus.AVAILABLE ||
          data.status === projectUnitStatus.NOT_AVAILABLE) && (
            <>

              {permissions && permissions.can_delete && <button onClick={() => dispatch(projectUnitDeleteConfirm(data))} className="cursor-pointer btn btn-delete" >
                {" "}
                <Trash />{" "}
              </button>}
            </>
          )}
        {(data.status === projectUnitStatus.SOLD || data.status === projectUnitStatus.BOOKED) && permissions && permissions.can_update && (
          <button onClick={() => { openDetailModal(data); }} className="cursor-pointer btn-pass btn">
            <BsEye />{" "}
          </button>
        )}
        {data.status === projectUnitStatus.AVAILABLE && bookingPermissions && bookingPermissions.can_write && (
          <button disabled={data.area > 0 ? false : true} className="cursor-pointer btn-pass btn"
            onClick={() => {
              props.onCreateOrEditBooking({ data: { ...data, ...{ project_unit_id: data.id } }, isEdit: false });
              props.onNavigate(routePaths.BOOKING_CREATE.path);
            }}>
            <span className="badge text-warning">Book Now</span>{" "}
          </button>
        )}
      </span>
    );
  };

  const openDetailModal = (data: ProjectUnitInterface) => {
    setUnitData(data);
    setOpen(true);
  };

  return (
    <>
      <DeleteModal isShow={projectData.showDeleteModal} close={() => { dispatch(projectUnitDeleteDecline()); }} onDelete={() => { props.onDeleteProjectUnit(id); }} />
      {permissions && permissions.can_read && <div className="app-page page-dashboard">
        <div className="d-flex justify-content-between align-items-center ">
          <PageTitle title="Project Units" backArrow={true} />
          {permissions && permissions.can_write && <Button
            className="btn btn-brand-1 mb-3"
            onClick={() => {
              props.onNavigate(routePaths.PROJECT_UNIT_CREATE.path + id);
            }}
          >
            {" "}
            <Plus size={20} className="ms-1" /> Add Unit
          </Button>}
        </div>
        <div className="table-card">
          {projectData && (
            <Grid
              rows={getFormatedProjectRow(projectData.projectList)}
              showSearch={true}
              headers={headers}
              showDateFilter={false}
              ShowLoader={projectData.loading}
              count={projectData.listCount}
              onPageChange={getProjectList}
              errorMessage={"No Project Unit Found"}
              onSort={onSortList}
            />
          )}
        </div>
      </div>}
      <ManageUnit isShow={open} isClose={(e: boolean) => { setOpen(false); e && onSortList(1); }} data={unitData} />
    </>
  );
};

const mapDispatchToProps = (dispatch: any) => ({
  getProjectUnits: (params: any) => dispatch(projectUnitsRequest(params)),
  onNavigate: (path: string) => dispatch(navigationRequest(path)),
  editProjectUnit: (data: ProjectUnitInterface) => dispatch(projectUnitEditPageRequest(data)),
  onDeleteProjectUnit: (id: string) => dispatch(projectUnitDeleteRequest(id)),
  onCreateOrEditBooking: (data: bookingAddOrEditRequestPayload) => dispatch(bookingAddOrEditRequest(data)),
});

export default connect(null, mapDispatchToProps)(ProjectUnitPage);
